"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class WikiUi {
    constructor(args) {
        this.ui = document.createElement('iframe');
        this.ui.id = 'wiki';
        this.ui.className = 'wiki';
        this.ui.src = 'https://en.m.wikipedia.org/wiki/Mammal';
        args.parent.appendChild(this.ui);
    }
}
exports.WikiUi = WikiUi;
/*
export class StringUiBrace
{
    public ui
    public ace
    public div

    constructor(args)
    {
        this.div = document.createElement('div')
        args.parent.appendChild(this.div)
        this.ace = ace.edit(this.div)
        this.ace.getSession().setMode('ace/mode/typescript')
        this.ace.setTheme('ace/theme/xcode')
    }
}*/
class StringUi //Monacco
 {
    constructor(args) {
        this.args = args;
        this.ui = document.createElement('div');
        this.ui.className = 'monaco-frame';
        this.ui.onclick = e => e.stopPropagation();
        this.args.parent.appendChild(this.ui);
        //console.log('monaco state', this.mon, StringUi.loading)
        /*
                if (!this.mon && !StringUi.loading)
                    this.ngAfterViewInit()
                else if (StringUi.loading)
                    StringUi.queue.push(()=> this.initMonaco())
                else
                    this.initMonaco()
                    */
    }
    ngAfterViewInit() {
        StringUi.loading = true;
        //console.log('ngAfterViewInit', StringUi.loading)
        var onGotAmdLoader = () => {
            window.require(['vs/editor/editor.main'], () => {
                //console.log('monaco state ongotloader', this.mon, StringUi.loading)
                this.initMonaco();
                StringUi.queue.forEach(e => e());
                monaco.editor.setTheme(this.args.theme || 'vs'); //'vs-dark')
                this.mon = monaco;
                StringUi.loading = false;
            });
        };
        if (!window.require) {
            var loaderScript = document.createElement('script');
            loaderScript.type = 'text/javascript';
            loaderScript.src = 'vs/loader.js';
            loaderScript.addEventListener('load', onGotAmdLoader);
            document.body.appendChild(loaderScript);
        }
        else
            onGotAmdLoader();
    }
    initMonaco() {
        /*
        this.editor = monaco.editor.create(this.ui, {
            value: '',
            //language: 'typescript',
            language: this.args.language || 'json',
            folding: true,
            showFoldingControls: 'always',
            dragAndDrop: true,
            codeLens: true,
            mouseWheelZoom: true,
            fontSize: 3,
            fontLigatures: true,
            minimap: { enabled:true }
        })
        
        this.editor.updateOptions({ fontSize: 12 })
        
        if (this.args.text)
            this.editor.setValue(this.args.text)

        this.editor.layout()
        
        if (!this.args.noresizelistener)
            this.enableResizeListener(true)
            */
    }
    enableResizeListener(on) {
        /*
        const rsl  = ()=> this.editor.layout()
        if (on) {
            this.ui.style.width = '100%'
            this.editor.updateOptions({ minimap: { enabled:true } })
            addResizeListener(this.ui, rsl) // calls this.editor.layout()
        }
        else {
            removeResizeListener(this.ui, rsl)
            this.ui.style.width = '200em'
            this.editor.updateOptions({ minimap: { enabled:false } })
            this.editor.layout()
        }*/
        //if (on)console.log('on')
        //else console.log('off')
    }
}
StringUi.loading = false;
StringUi.queue = [];
exports.StringUi = StringUi;



//////////////////
// WEBPACK FOOTER
// ./dist/js/components/primitive/index.js
// module id = 230
// module chunks = 0